<template>
  <div>
    <page-header
      :actions="pageActionConfig"
      left-side-class="col-xl-4"
      :page="pageConfig"
      right-side-class="col-xl-8 align-items-end d-flex pb-2 justify-content-end"
    />
    <create-budget
      v-if="openCreateBudget"
      :academic-years="academicYearsForServiceBudget"
      title="Crear Nuevo Presupuesto"
      @on-cancel="openCreateBudget = false"
      @on-save="onSaveBudgetHandler"
    />
    <div class="bg-secondary-3 rounded p-3 searchbar-custom">
      <div class="row">
        <div class="col-12 d-flex d-md-flex d-sm-block">
          <custom-drop-down
            v-model="budgetSelectedAcademicYear"
            class="w-72"
            :clearable="false"
            fieldkey="id"
            fieldname="name"
            :options="academicYears"
            placeholder="Seleccione Año Académico"
          />
          <action-button
            i="fa fa-search"
            variant="success ml-3 px-n5"
            @click="onSearchHandler"
          >
            Buscar
          </action-button>
        </div>
      </div>
    </div>
    <separator class="my-3" text="Resultado de Presupuesto" />
    <search-result
      :academic-years="academicYears"
      :result-data="resultData"
      @on-edit-budget="onSaveBudgetHandler"
      @on-open-details="onOpenDetailsHandler"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import PageHeader from 'PageHeader';
import Separator from 'custom-separator';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import SearchResult from './SearchResult';
import alertMixin from 'utils/mixins/alert.mixin';
import { CreateBudget } from './components';
import {
  getBudgetsAcademicYears as _getBudgetsAcademicYears,
  saveServiceBudget as _saveServiceBudget,
  getBudgetDetails as _getBudgetDetails,
} from '@/modules/shared/budget.api.js';
import { getAcademicYearsForServiceBudget as _getAcademicYearsForServiceBudget } from '@/modules/shared/academicyear.api.js';

export default {
  name: 'MainServiceRequestBudget',
  components: {
    PageHeader,
    Separator,
    ActionButton,
    CustomDropDown,
    SearchResult,
    CreateBudget,
  },
  mixins: [alertMixin],
  data() {
    return {
      openCreateBudget: false,
      budgetSelectedAcademicYear: null,
      academicYears: [],
      academicYearsForServiceBudget: [],
      resultData: {
        header: {},
        body: null,
      },
    };
  },
  computed: {
    pageConfig() {
      return {
        icon: 'fas fa-book',
        title: 'Presupuesto',
        routes: ['Inicio', 'Becas', 'Presupuesto'],
      };
    },
    pageActionConfig() {
      return [
        {
          text: 'Crear Nuevo Presupuesto',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: this.onAddnewBudget,
          class: 'mt-4',
          visible: this.userHasPermissions('scolarship.budget'),
        },
      ];
    },
  },
  async mounted() {
    await this.callGetBudgetsAcademicYears();
    await this.callGetAcademicYears();
  },
  methods: {
    async callGetBudgetsAcademicYears() {
      const { data } = await _getBudgetsAcademicYears();
      this.academicYears = data;
      this.budgetSelectedAcademicYear = data[0];
      await this.searchBudgedDetails();
    },
    async callGetAcademicYears() {
      const { data } = await _getAcademicYearsForServiceBudget();
      this.academicYearsForServiceBudget = data;
    },
    onAddnewBudget() {
      this.openCreateBudget = true;
    },
    async onSearchHandler() {
      await this.searchBudgedDetails();
    },
    async searchBudgedDetails() {
      const { data } = await _getBudgetDetails(
        this.budgetSelectedAcademicYear.id
      );
      if (data) {
        const first = data.filter((x) => x)[0];
        if (first) {
          this.resultData.body = data;
          const dataFiltered = data.filter((x) => x);
          const values = {
            budgetAmt: first.budgetAmt,
            paid: _.sumBy(dataFiltered, (x) => x.paid),
            actual: _.sumBy(dataFiltered, (x) => x.actual),
            projected: _.sumBy(dataFiltered, (x) => x.projected),
          };
          const _body = dataFiltered.filter(
            (x) => x.paid || x.actual || x.projeted || x.studentCount
          );
          this.resultData = {
            header: {
              academicYear: first.academicYearName,
              academicYearId: first.academicYearId,
              serviceBudgetId: first.serviceBudgetId,
              budget: values.budgetAmt,
              paid: values.paid,
              actual: values.actual,
              projected: values.projected,
              available: values.budgetAmt - values.paid,
            },
            body: _body,
          };
        }
      }
    },
    async onSaveBudgetHandler(model) {
      const params = {
        ...model,
        academicYearId: model.academicYear?.id,
      };

      var msj = 'Su presupuesto fue guardado exitosamente.';

      if (model.id != null) {
        msj = 'Su presupuesto fue editado correctamente.';
      }

      _saveServiceBudget(params)
        .then(async () => {
          this.ShowToast('', msj, 'success');
          this.budgetSelectedAcademicYear = model.academicYear;
          await this.onSearchHandler();
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
      this.openCreateBudget = false;
    },
    onOpenDetailsHandler(index) {
      this.resultData = {
        ...this.resultData,
        body: this.resultData.body.map((item, itemIndex) => {
          if (index === itemIndex) {
            item.isOpen = !item.isOpen;
          } else {
            item.isOpen = false;
          }
          return item;
        }),
      };
    },
  },
};
</script>

<style scoped>
.searchbar-custom {
  max-width: 450px;
}
</style>
